import { Reveal } from "../components/Reveal";
import { ImageReveal } from "../components/ImageReveal";
import { DropHeading } from "./DropHeading";

export const ErthStory = () => (
  <section id="story" data-testid="erth-story" className="bg-erth-beige py-20 lg:py-36">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 sm:px-8 lg:grid-cols-12 lg:gap-16">
      <Reveal className="lg:col-span-7">
        <p className="mb-6 font-body text-sm tracking-[0.25em] text-erth-black/50">our story</p>
        <DropHeading
          testId="erth-story-heading"
          text="building the future with unique designs, sustainable green homes, and unforgettable experiences"
          className="text-2xl leading-[1.25] text-erth-black sm:text-3xl lg:text-4xl"
        />
        <p className="mt-8 max-w-2xl font-body text-lg font-light leading-relaxed text-erth-black/80 sm:text-xl">
          Welcome to Erth Escapes, where we create innovative spaces that harmonize with nature. Our commitment to
          sustainable living and modern design results in homes and experiences that inspire and connect.
        </p>
        <p className="mt-5 max-w-2xl font-body text-lg font-light leading-relaxed text-erth-black/80 sm:text-xl">
          From eco-conscious residences to immersive adventure retreats, Erth Escapes brings you thoughtfully
          crafted environments that redefine living, celebrating, and reconnecting with the people around you and
          the world around us.
        </p>
      </Reveal>
      <ImageReveal
        src="/images/courtyard-walk.webp"
        alt="A shaded courtyard walk lined with greenery"
        tone="licorice"
        testId="erth-story-image"
        className="aspect-[4/5] lg:col-span-5"
      />
    </div>
  </section>
);
